import type {
  RectificationCandidateOut,
  RectificationEventInput,
  RectificationEventMatch,
  RectificationEventType,
  RectificationRequest,
  RectificationResponse,
} from "@ishvaram/api-client";

export type {
  RectificationCandidateOut,
  RectificationEventInput,
  RectificationEventMatch,
  RectificationEventType,
  RectificationRequest,
  RectificationResponse,
};
import { apiRequest } from "./_fetch";

/**
 * Rank candidate birth minutes for an uncertain birth window.
 *
 * The response is a ranking, never a verified birth time — render its
 * `boundary` alongside the candidates (rule 29).
 */
export async function rectifyBirthTime(data: RectificationRequest): Promise<RectificationResponse> {
  return apiRequest<RectificationResponse>("/rectification", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export type {
  BirthTimeSensitivityRequest,
  BirthTimeSensitivityResponse,
} from "@ishvaram/api-client";
import type {
  BirthTimeSensitivityRequest,
  BirthTimeSensitivityResponse,
} from "@ishvaram/api-client";

export function compareBirthTimes(
  data: BirthTimeSensitivityRequest
): Promise<BirthTimeSensitivityResponse> {
  return apiRequest<BirthTimeSensitivityResponse>("/birth-time-sensitivity", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}
